export const metaInfo = {
  name: "sample-app",
  version: "6.1.0",
  type: "sample",
  platform: "React",
};
